
function setCookie(name, value, options = {}) {
  // Start with the encoded name and value pair
  let cookieStr = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  if (options.expires) {
    let expires = options.expires;
    if (typeof expires === "number") {
      const date = new Date();
      date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
      expires = date;
    }
    if (expires instanceof Date) {
      cookieStr += "; expires=" + expires.toUTCString();
    } else if (typeof expires === "string") {
      cookieStr += "; expires=" + expires;
    }
  }
  cookieStr += "; path=" + (options.path || "/");
  if (options.domain) {
    cookieStr += "; domain=" + options.domain;
  }
  if (options.secure) {
    cookieStr += "; secure";
  }
  if (options.sameSite) {
    cookieStr += "; samesite=" + options.sameSite;
  }

  document.cookie = cookieStr;
}


function getCookie(name) {
  const cookies = document.cookie.split(';');
  // Loop through all cookies
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(name + "=") === 0) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }
  return null;
}

if(document.referrer.includes('register')) {
  const userCookie = getCookie("user");
  console.log(userCookie, 'cookie data');
  if(userCookie == null) {
    setCookie("user", "JohnDoe", {
      expires: 7,           // Cookie expires in 7 days
      path: "/",            // Accessible across the entire site
      secure: true,         // Only over HTTPS
      sameSite: "Lax"       // 'Lax' provides reasonable CSRF protection
    });
    setTimeout(() => {
      location.reload();
    },1000)
  }
  else{
    document.querySelector('.opacity-0').classList.remove('opacity-0');
  }
}
else{
  document.querySelector('.opacity-0').classList.remove('opacity-0');
}
